import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import Home from "./pages/Home";
import Admin from "./pages/admin/Admin";
import Challenge from "./pages/admin/Challenge";
import AOS from "aos";
import "./styles/global.css";
import Login from "./pages/Login";
import Albums from "./pages/Albums";
import AlbumView from "./pages/Album";
import PrivateRoute from "./Auth/PrivateRoute";

AOS.init({ duration: 1000, once: true });

const AppContent: React.FC = () => {
  // rotas onde você NÃO quer navbar
  return (
    <>
      <Routes>
      {/* Públicas */}
      <Route path="/login" element={<Login />} />

      {/* Protegidas */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="/albums" element={<Albums />} />
        <Route path="/album/:id" element={<AlbumView />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/challenge" element={<Challenge />} />
      </Route>
    </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
